// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28Fv2","toggle":"styles_toggle__S5Nek","preview":"styles_preview__1yE1I"};